import { Injectable, inject } from "@angular/core";
import { TranslocoService } from "@jsverse/transloco";
import { LorenHttpResponseError } from "../../interfaces/loren-http-response-error.interface";
import { LorenHttpResponseErrorStatuses } from "../../constants/loren-http-response-error-statuses.constants";

@Injectable({
  providedIn: "root",
})
export class LorenHttpErrorTranslationService {
  private translateService = inject(TranslocoService);

  private static readonly ERRORS_WRONG_CURRENT_PASSWORD =
    "errors_api.wrong_current_password";
  private static readonly ERRORS_NEW_PASSWORD_REQUIREMENTS =
    "errors_api.new_password_requirements";
  private static readonly ERRORS_EMAIL_INVALID = "errors_api.email_invalid";
  private static readonly ERRORS_USERNAME_TOO_SHORT =
    "errors_api.username_too_short";
  private static readonly USERNAME_ALREADY_REGISTERED =
    "errors_api.username_already_registered";
  private static readonly ERRORS_EMAIL_ALREADY_REGISTERED =
    "errors_api.email_already_registered";
  private static readonly ERRORS_IMAGE_TOO_LARGE = "errors_api.image_too_large";
  private static readonly ERRORS_OPERATION_SYSTEM_ERROR =
    "operations.system_error";
  private static readonly SAME_PASSWORD = "errors_api.same_password";

  private static readonly labels: Record<string, string> = {
    [LorenHttpResponseErrorStatuses.INVALID_PASSWORD]:
      LorenHttpErrorTranslationService.ERRORS_WRONG_CURRENT_PASSWORD,
    [LorenHttpResponseErrorStatuses.PASSWORD_TOO_SHORT]:
      LorenHttpErrorTranslationService.ERRORS_NEW_PASSWORD_REQUIREMENTS,
    [LorenHttpResponseErrorStatuses.EMAIL_INVALID]:
      LorenHttpErrorTranslationService.ERRORS_EMAIL_INVALID,
    [LorenHttpResponseErrorStatuses.USERNAME_TOO_SHORT]:
      LorenHttpErrorTranslationService.ERRORS_USERNAME_TOO_SHORT,
    [LorenHttpResponseErrorStatuses.USERNAME_ALREADY_REGISTERED]:
      LorenHttpErrorTranslationService.USERNAME_ALREADY_REGISTERED,
    [LorenHttpResponseErrorStatuses.EMAIL_ALREADY_REGISTERED]:
      LorenHttpErrorTranslationService.ERRORS_EMAIL_ALREADY_REGISTERED,
    [LorenHttpResponseErrorStatuses.IMAGE_TOO_LARGE]:
      LorenHttpErrorTranslationService.ERRORS_IMAGE_TOO_LARGE,
    [LorenHttpResponseErrorStatuses.OPERATION_SYSTEM_ERROR]:
      LorenHttpErrorTranslationService.ERRORS_OPERATION_SYSTEM_ERROR,
    [LorenHttpResponseErrorStatuses.SAME_PASSWORD]:
      LorenHttpErrorTranslationService.SAME_PASSWORD,
  };

    getTranslatedErrorsFromResponse(
        responseErrors: LorenHttpResponseError[]
    ): string[] {
        return responseErrors.map((err) => {
                return this.translateService.translate(
                    LorenHttpErrorTranslationService.labels[err.statusMessage]
                );
            }
        );
    }
}
